import React, { useState, useRef, useEffect } from 'react';
import styles from './ImageEditor.module.scss';

function ImageEditor({ initialImage = null, onLocalChange, onDelete, canUpdatePreview = true }) {
  const [preview, setPreview] = useState(initialImage);
  const [pendingPreview, setPendingPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  // Quand le parent autorise l'affichage de la preview
  useEffect(() => {
    if (canUpdatePreview && pendingPreview) {
      setPreview(pendingPreview);
      setPendingPreview(null);
    }
  }, [canUpdatePreview, pendingPreview]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setError(null);

    const localUrl = URL.createObjectURL(file);
    setPendingPreview(localUrl); // on attend validation
    await onLocalChange(file);   // c'est le parent qui autorisera ou non l'affichage
  };

  const handleDelete = async () => {
    if (!window.confirm('Supprimer cette image ?')) return;
    setLoading(true);
    setError(null);
    try {
      await onDelete();
      setPreview(null);
    } catch (err) {
      setError('Erreur lors de la suppression.');
      console.error(err);
    }
    setLoading(false);
  };

  const handleClickUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // 👈 déclenche l'ouverture du file picker
    }
  };

  return (
    <div className={styles.imageEditor}>
      {loading && <p className={styles.loading}>Chargement...</p>}

      {preview ? (
        <div className={styles.previewContainer}>
          <img src={preview} alt="Image actuelle" className={styles.previewImg} />
          <div className={styles.buttonGroup}>
            <button
              type="button"
              onClick={handleClickUpload}
              className={styles.modifyButton}
            >
              Modifier l'image
            </button>
            <button
              type="button"
              onClick={handleDelete}
              className={styles.deleteButton}
            >
              Supprimer l'image
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.noImageContainer}>
          {/* <p className={styles.noImage}>Aucune image</p> */}
          <button
            type="button"
            onClick={handleClickUpload}
            className={styles.addButton}
          >
            Ajouter une image
          </button>
        </div>
      )}

      {/* input caché */}
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />

      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}

export default ImageEditor;
